module.exports = __webpack_public_path__ + "static/media/new_cat_pack_FR_285x350.9c7d41a4.png";